export enum PropBoundOrientation {
  LONG_PROP = "LONG_PROP",
  CENTER_PROP = "CENTER_PROP",
  CENTROID_PROP = "CENTROID_PROP",
}

export enum PlacementStyleVersion {
  DEPRECATED = "DEPRECATED",
  VERSION_0 = "VERSION_0",
}
